module.exports = __webpack_public_path__ + "img/shopThr.3ee9bb8e.png";